/** Highlights matching substring in text (case-insensitive). */
export function highlightMatch(text: string, query: string) {
  const trimmed = query.trim()
  if (!trimmed) return text

  const lower = text.toLowerCase()
  const q = trimmed.toLowerCase()
  const index = lower.indexOf(q)
  if (index === -1) return text

  return (
    <>
      {text.slice(0, index)}
      <mark className="rounded-sm bg-primary/25 px-0.5 text-inherit">{text.slice(index, index + trimmed.length)}</mark>
      {text.slice(index + trimmed.length)}
    </>
  )
}
